<template>
<div class="chapter">
<div class="inner_page">
<div class="contents">
<p class="centerImage00"><img alt="image" src="images/toc.jpg" width="50%"/></p>
<p class="contentsEntry"><span href="#/e9780545746076_title001" title="Link target outside of Sample">Title Page</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ded001" title="Link target outside of Sample">Dedication</span></p>
<p class="contentsEntry"><a href="#/e9780545746076_ch001"><em class="italic">Peggy Sue</em></a></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch002" title="Link target outside of Sample">Water, water everywhere</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch003" title="Link target outside of Sample">Ship’s log</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch004" title="Link target outside of Sample">Gibbons and ghosts</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch005" title="Link target outside of Sample">I, Kensuke</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch006" title="Link target outside of Sample"><em class="italic">Abunai!</em></span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch007" title="Link target outside of Sample">All that silence said</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch008" title="Link target outside of Sample">Everyone dead in Nagasaki</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch009" title="Link target outside of Sample">The night of the turtles</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ch010" title="Link target outside of Sample">Killer men come</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_bm001" title="Link target outside of Sample">Postscript</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_bm002" title="Link target outside of Sample">Glossary</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_ata001" title="Link target outside of Sample">About the Author</span></p>
<p class="contentsEntry"><span href="#/e9780545746076_copy001" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545746076_toc001.vue?760b79de